import React, { createContext, useContext, useState, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import MuiAlert from '@mui/material/Alert';
const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = "info", duration = 3000) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), duration);
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
       {notification && (
        <MuiAlert
          severity={notification.type} // Maps to success, error, info, warning
          variant="filled"
          elevation={6}
          sx={{
            position: "fixed",
            bottom: 20,
            right: 20,
            zIndex: 9999,
            transition: "none", // Disable animations to avoid scrollTop error
            "& .MuiAlert-message": {
              fontWeight: 500,
              padding: "6px 16px",
            },
            "& .MuiAlert-root": {
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            },
          }}
          slotProps={{
            message: {
              style: { transition: "none" }, // Extra precaution to disable message animation
            },
          }}
        >
          {notification.message}
        </MuiAlert>
      )}
    </NotificationContext.Provider>
  );
};
